import React from 'react';
import { LocaleOptions } from 'helpers/types';
import { i18n } from 'config/locales/i18n';
import i18nNew from 'util/i18n';
import { addTestClassName } from 'helpers/testHelper';

interface Props {
  /**
   * Locale identifier. Format is usually `error.{something}.{something}`, like
   * `error.name.last.pattern`
   */
  localeId: string

  /**
   * This overwrites the locale title.
   */
  title?: string

  /**
   * This overwrites the locale message.
   */
  message?: string

  /**
   * This overwrites the locale note.
   */
  note?: string

  /**
   * Locale Options. This can contain additional parameters that can be injected
   * into a locale.
   */
  localeOptions?: LocaleOptions
}

/**
 * This is a component replacement for renderMessage function.
 */
export const ErrorMessageItem: React.FC<Props> = ({
  localeId,
  title,
  message,
  note,
  localeOptions,
}) => {
  const noteId = `${localeId}.note`;
  const isNoteValid = i18n.value(noteId) !== '';
  const messageId = `${localeId}.message`;
  const isMessageValid = i18n.value(messageId) !== '';

  return (
    <div data-i18n={localeId} className={addTestClassName('ErrorMessageItem')}>
      <h5 className="usa-alert-heading">
        {title ?? i18nNew.t(`${localeId}.title`, localeOptions?.titleParameters)}
      </h5>

      {isMessageValid && (
        <span className="help-link">
          <span>{message ?? i18nNew.m(messageId, localeOptions?.messageParameters)}</span>
        </span>
      )}

      {isNoteValid && (
        <span className="help-link">
          <em>{note ?? i18nNew.m(noteId, localeOptions?.noteParameters)}</em>
        </span>
      )}
    </div>
  );
};
